// What I know how to do
export const skillCategories = [
  {
    title: 'Frontend Development',
    skills: [
      { name: 'React', icon: 'SiReact', level: 'Advanced' },
      { name: 'JavaScript', icon: 'SiJavascript', level: 'Advanced' },
      { name: 'HTML5', icon: 'SiHtml5', level: 'Expert' },
      { name: 'CSS3', icon: 'SiCss3', level: 'Advanced' },
      { name: 'TailwindCSS', icon: 'SiTailwindcss', level: 'Advanced' },
      { name: 'React Router', icon: 'SiReactrouter', level: 'Advanced' },
      { name: 'Context API', icon: 'CodeBracketIcon', level: 'Advanced' },
      { name: 'Responsive Design', icon: 'DevicePhoneMobileIcon', level: 'Advanced' },
      { name: 'Component Architecture', icon: 'CodeBracketIcon', level: 'Advanced' },
      { name: 'State Management', icon: 'CpuChipIcon', level: 'Advanced' },
      { name: 'Error Handling', icon: 'CheckCircleIcon', level: 'Intermediate' },
    ],
  },
  {
    title: 'UI/UX & Design',
    skills: [
      { name: 'Figma', icon: 'SiFigma', level: 'Intermediate' },
      { name: 'CSS Grid', icon: 'PaintBrushIcon', level: 'Advanced' },
      { name: 'Flexbox', icon: 'PaintBrushIcon', level: 'Advanced' },
      { name: 'CSS Animations', icon: 'SparklesIcon', level: 'Intermediate' },
      { name: 'Material Design', icon: 'PaintBrushIcon', level: 'Beginner' },
      { name: 'Accessibility', icon: 'CheckCircleIcon', level: 'Intermediate' },
      { name: 'Cross-browser', icon: 'GlobeAltIcon', level: 'Advanced' },
      { name: 'Mobile First', icon: 'DevicePhoneMobileIcon', level: 'Advanced' },
      { name: 'User Experience', icon: 'CheckCircleIcon', level: 'Intermediate' },
      { name: 'UI Design', icon: 'PaintBrushIcon', level: 'Intermediate' },
    ],
  },
  {
    title: 'Development Tools',
    skills: [
      { name: 'Git', icon: 'SiGit', level: 'Advanced' },
      { name: 'GitHub', icon: 'SiGithub', level: 'Intermediate' },
      { name: 'VS Code', icon: 'CodeBracketIcon', level: 'Advanced' },
      { name: 'Chrome DevTools', icon: 'MagnifyingGlassIcon', level: 'Advanced' },
      { name: 'ESLint', icon: 'MagnifyingGlassIcon', level: 'Intermediate' },
      { name: 'Prettier', icon: 'DocumentTextIcon', level: 'Intermediate' },
      { name: 'Webpack', icon: 'SiWebpack', level: 'Beginner' },
      { name: 'Debugging', icon: 'MagnifyingGlassIcon', level: 'Advanced' },
      { name: 'Code Organization', icon: 'CodeBracketIcon', level: 'Advanced' },
      { name: 'Testing', icon: 'CheckCircleIcon', level: 'Intermediate' },
      { name: 'Performance Optimization', icon: 'SparklesIcon', level: 'Intermediate' },
    ],
  },
];

export const additionalSkills = [
  'Problem Solving',
  'Learning Agility',
  'Team Collaboration',
  'Continuous Learning',
  'Agile Development',
  'Project Management',
  'Communication Skills',
  'SEO Basics',
  'Time Management',
  'Adaptability',
  'Critical Thinking',
  'Mentoring',
  'Leadership',
  'Innovation',
  'Work Ethic',
];
